export * from "ce/api/WorkspaceApi";
import { default as CE_WorkspaceApi } from "ce/api/WorkspaceApi";

class WorkspaceApi extends CE_WorkspaceApi {}

export default WorkspaceApi;
